// Academy 课程数据读取
// 数据来源: data/curriculum.json
// 由 server/data/curriculum.json 镜像

import curriculumData from '../data/curriculum.json';
import { PROBLEMS } from './problems.js';

export const CURRICULUM = curriculumData;

// 给 problem 加 branch + level (从 difficulty 推断)
function diffToLevel(d) {
  if (d <= 2) return 1;
  if (d === 3) return 2;
  if (d === 4) return 3;
  return 4;
}
const CAT_TO_BRANCH = {
  mathematics: 'MATH', physics: 'PHYS', chemistry: 'CHEM', biology: 'BIO',
  cs: 'CS', materials: 'MATE', philosophy: 'PHIL', engineering: 'ENG', social: 'SOC',
};

export function getProblemBranchLevel(p) {
  const branch = CAT_TO_BRANCH[p.category] || 'MATH';
  const level = diffToLevel(p.difficulty || 3);
  return { branch, level, cellId: `${branch}.L${level}` };
}

// 通过 cellId 拿 cell 信息 + 关联 problem
export function getCell(cellId) {
  return CURRICULUM.cells[cellId] || null;
}

// 通过 cellId 拿所有 problems (按 difficulty 升序)
export function getCellProblems(cellId) {
  const cell = getCell(cellId);
  if (!cell) return [];
  return PROBLEMS
    .filter(p => {
      const { branch, level } = getProblemBranchLevel(p);
      return branch === cell.branch && level === cell.level;
    })
    .sort((a, b) => (a.difficulty || 0) - (b.difficulty || 0));
}

// 通过 branch + level 拿代表 5 题
export function getCellRepresentative(cellId) {
  const cell = getCell(cellId);
  if (!cell) return [];
  return (cell.representative || []).map(id => PROBLEMS.find(p => p.id === id)).filter(Boolean);
}

// 通过 branch 拿所有 cells
export function getBranchCells(branch) {
  return Object.values(CURRICULUM.cells).filter(c => c.branch === branch);
}

// 通过 branch 拿 problems
export function getBranchProblems(branch) {
  return PROBLEMS.filter(p => {
    const { branch: b } = getProblemBranchLevel(p);
    return b === branch;
  });
}

// 拿 prereqs 关系
export function getPrereqs() {
  return CURRICULUM.prereqs || [];
}

// 拿跨分支桥
export function getCrossBridges() {
  return CURRICULUM.cross_bridges || [];
}

// 统计
export function getCurriculumStats() {
  return CURRICULUM.stats;
}

// 9 大分支顺序
export const BRANCH_ORDER = ['MATH', 'PHYS', 'CHEM', 'BIO', 'CS', 'MATE', 'PHIL', 'ENG', 'SOC'];

// 4 阶梯
export const LEVEL_ORDER = [1, 2, 3, 4];
